import styled from '@emotion/styled'
import { Search, Times } from '@mehilainen/mds-customer/icons'
import React from 'react'
import { KeyboardEvent } from 'react'
import { useTranslation } from 'react-i18next'

const EndAdornmentContainer = styled.div`
  cursor: pointer;
`

interface Props {
  value: string
  setValue(value: string): void
}

const SearchEndAdornment: React.FC<React.PropsWithChildren<Props>> = ({ value, setValue }) => {
  const { t } = useTranslation()

  const onKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') {
      setValue('')
    }
  }
  return (
    <EndAdornmentContainer
      onClick={() => setValue('')}
      onKeyDown={onKeyDown}
      tabIndex={value.length > 0 ? 0 : 1}
      aria-label={t('component.filterOptions.reset')}
      role="button"
    >
      {value ? <Times /> : <Search />}
    </EndAdornmentContainer>
  )
}

export default SearchEndAdornment
